import { useCallback, useState } from "react";

export const STORAGE_PREFIX = "german-noun-articles:";

// Reads and writes are wrapped because Safari private mode throws on access
// rather than returning null - losing a setting is fine, a page that won't
// render isn't.
export function readStored(key, fallback) {
  try {
    const stored = window.localStorage.getItem(STORAGE_PREFIX + key);
    return stored === null ? fallback : JSON.parse(stored);
  } catch (e) {
    return fallback;
  }
}

export function writeStored(key, value) {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
  } catch (e) {
    // Out of quota or blocked - the in-memory value still works for this visit.
  }
}

// There's no backend behind the anonymous experience, so known words and
// settings live in localStorage. For a signed in user the same values are
// mirrored to the server; see useLabSync.
export default function useLocalStorage(key, fallback) {
  const [value, setValue] = useState(() => readStored(key, fallback));

  const store = useCallback(
    (next) => {
      setValue((previous) => {
        const resolved = typeof next === "function" ? next(previous) : next;
        writeStored(key, resolved);
        return resolved;
      });
    },
    [key]
  );

  return [value, store];
}
